<template>
  <WdsButtonGhost :disabled="notesCount === 0" @click.stop="openNotesPanel">
    <WdsIcon v-if="notesCount > 0" :name="WdsIconNameEnum.DOCUMENT_ALT" :size="16" />
  </WdsButtonGhost>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsButtonGhost, WdsIcon, WdsIconNameEnum } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import { useTablePanels } from '@/components/GraphqlDataTable/useTablePanels'

const { openWorkerDetailPanel } = useTablePanels()

const TrustedContactNotesColumn = graphql(`
  fragment TrustedContactNotesColumn on TrustedContact {
    id
    worker {
      id
    }
    notes(first: 1) {
      paginatorInfo {
        total
      }
    }
  }
`)

const props = defineProps<{ row: FragmentType<typeof TrustedContactNotesColumn> }>()
const column = computed(() => useFragment(TrustedContactNotesColumn, props.row))
const notesCount = computed(() => column.value.notes.paginatorInfo.total)

const openNotesPanel = () => {
  if (notesCount.value > 0) {
    openWorkerDetailPanel({
      workerAccountId: column.value.worker.id,
      tabKey: 'trusted-contact-notes',
    })
  }
}
</script>

<style scoped></style>
